import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginAction, saveLogin } from "../../redux/slices/mainDataSlice";
import { useForm } from "react-hook-form";

/* Mini dashboard illustration for the decorative side panel (admin flavor). */
const STAT_TONES = ["tt-illust__tone-teal", "tt-illust__tone-gold", "tt-illust__tone-white"];
const BARS = [38, 62, 45, 78, 55, 88, 66];

function LoginPanelArt() {
  return (
    <div className="tt-login__panel" aria-hidden="true">
      <div className="tt-login__grid-texture" />
      <div className="tt-login__glow tt-login__glow--teal" />
      <div className="tt-login__glow tt-login__glow--gold" />

      <div className="tt-illust">
        <div className="tt-illust__head">
          <span className="tt-illust__dot" />
          <span className="tt-illust__bar tt-illust__bar--long" />
          <span className="tt-illust__bar tt-illust__bar--short" />
        </div>

        <div className="tt-illust__stats">
          {STAT_TONES.map((tone, i) => (
            <div
              key={tone}
              className={`tt-illust__stat ${tone}`}
              style={{ animationDelay: `${250 + i * 90}ms` }}
            >
              <div className="tt-illust__stat-line tt-illust__stat-line--long" />
              <div className="tt-illust__stat-line tt-illust__stat-line--short" />
            </div>
          ))}
        </div>

        <div className="tt-illust__chart">
          {BARS.map((h, i) => (
            <div
              key={i}
              className="tt-illust__chart-bar"
              style={{ height: `${h}%`, animationDelay: `${500 + i * 70}ms` }}
            />
          ))}
        </div>

        <div className="tt-illust__rows">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="tt-illust__row"
              style={{ animationDelay: `${950 + i * 90}ms` }}
            >
              <span className="tt-illust__row-dot" />
              <span className="tt-illust__row-line" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Login() {
  const [loginStatus, setLoginStatus] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuth = useSelector((state) => state.main.isAuthenticated);
  const { register, handleSubmit } = useForm();

  useEffect(() => {
    const targetPath = "/home";

    if (isAuth) {
      navigate(targetPath);
    } else {
      const storedUserCredentials = JSON.parse(
        localStorage.getItem("userCredentials")
      );
      if (storedUserCredentials) {
        dispatch(saveLogin(storedUserCredentials));
        navigate(targetPath);
      }
    }
  }, [isAuth, dispatch, navigate]);

  const loginHandler = handleSubmit((data) => {
    setLoginStatus(true);

    dispatch(loginAction(data))
      .then(() => {
        setLoginStatus(false);
      })
      .catch((err) => {
        console.error(err);
        setLoginStatus(false);
      });
  });

  return (
    <div className="tt-login">
      <div className="tt-login__form-side">
        <form className="tt-login__form" onSubmit={loginHandler}>
          <div className="tt-login__brand">
            <img
              src="/images/user.png"
              alt="الفارس"
              className="tt-login__logo"
            />
            <h1 className="tt-login__title">إدارة المدارس الحكومية</h1>
            <p className="tt-login__subtitle">سجّل الدخول للمتابعة</p>
          </div>

          <div className="tt-login__fields">
            <label className="tt-field">
              <span className="tt-field__label">اسم المستخدم</span>
              <input
                type="text"
                className="tt-input"
                autoComplete="username"
                required
                autoFocus
                {...register("username")}
              />
            </label>

            <label className="tt-field">
              <span className="tt-field__label">كلمة المرور</span>
              <input
                type="password"
                className="tt-input"
                autoComplete="current-password"
                required
                {...register("password")}
              />
            </label>

            <button
              type="submit"
              className="tt-btn"
              disabled={loginStatus}
            >
              {loginStatus ? "جارٍ الدخول…" : "دخول"}
            </button>
          </div>
        </form>
      </div>

      <LoginPanelArt />
    </div>
  );
}
